<div class="row">
    <div class="large-3 medium-6 small-12">
        <mat-spinner></mat-spinner>
    </div>
    <div class="large-9 medium-6 small-12" class="grade-submitting-text">
        <div *ngIf="validationStatus.totalCount > 0 && validationStatus.currentCount !== validationStatus.totalCount">
            {{validationStatus.currentCount}} of {{validationStatus.totalCount}} grades have been submitted.
        </div>

        <div *ngIf="validationStatus.totalCount === 0 ">
            <app-text [alias]="'grade_submit_status_initial_state'" [interpolationObject]="validationStatus"></app-text>
        </div>

        <div *ngIf="validationStatus.totalCount > 0 && validationStatus.currentCount === validationStatus.totalCount">
            <app-text [alias]="'grade_submit_status_complete_post'" [interpolationObject]="validationStatus"></app-text>
        </div>


    </div>
</div>